import { render, staticRenderFns } from "./NewLicenseKind.vue?vue&type=template&id=398fed78&scoped=true"
import script from "./NewLicenseKind.vue?vue&type=script&lang=js"
export * from "./NewLicenseKind.vue?vue&type=script&lang=js"
import style0 from "./NewLicenseKind.vue?vue&type=style&index=0&id=398fed78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398fed78",
  null
  
)

export default component.exports